<div role="status" data-test="mailbox-gate"
     style="display: flex; align-items: center; justify-content: space-between; gap: 16px; padding: 12px 14px; border: 1px solid var(--amber); border-radius: 8px; background: var(--amber-l);">
    <div>
        <div class="body-sm" style="font-weight: 700; color: var(--amber-d);" data-test="mailbox-gate-title">{{ title }}</div>
        <div class="body-xs mt-1" style="color: var(--fg-muted);" data-test="mailbox-gate-message">{{ message }}</div>
    </div>
    <a class="btn btn-amber btn-sm" routerLink="/user-settings" [queryParams]="{ tab: 'connected' }" data-test="mailbox-gate-connect" style="flex-shrink: 0;">{{ actionLabel }}</a>
</div>
